module.exports = __webpack_public_path__ + "static/media/iphone-box-view.6098a4bb.jpg";